/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_EyebrowInputs */

const tr_iade_iptal_eyebrow = /** @type {(inputs: Iade_Iptal_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ABONELİK İPTAL VE FESİH POLİTİKASI`)
};

const en_iade_iptal_eyebrow = /** @type {(inputs: Iade_Iptal_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SUBSCRIPTION CANCELLATION AND TERMINATION POLICY`)
};

const de_iade_iptal_eyebrow = /** @type {(inputs: Iade_Iptal_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RICHTLINIE ZU KÜNDIGUNG UND BEENDIGUNG DES ABONNEMENTS`)
};

const ru_iade_iptal_eyebrow = /** @type {(inputs: Iade_Iptal_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ПОЛИТИКА ОТМЕНЫ И РАСТОРЖЕНИЯ ПОДПИСКИ`)
};

/**
* | output |
* | --- |
* | "SUBSCRIPTION CANCELLATION AND TERMINATION POLICY" |
*
* @param {Iade_Iptal_EyebrowInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_eyebrow = /** @type {((inputs?: Iade_Iptal_EyebrowInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_EyebrowInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_eyebrow(inputs)
	if (locale === "de") return de_iade_iptal_eyebrow(inputs)
	if (locale === "ru") return ru_iade_iptal_eyebrow(inputs)
	return tr_iade_iptal_eyebrow(inputs)
});